import axios from 'axios'
import toast from 'react-hot-toast'

// Configuración base de la API
const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8888'

// Build version - generado automáticamente en CI/CD
const BUILD_VERSION = import.meta.env.VITE_BUILD_TIME || 'dev'

// Crear instancia de axios
export const apiClient = axios.create({
  baseURL: `${API_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
    'X-Client-Version': BUILD_VERSION,
  },
  timeout: 10000,
  withCredentials: true, // Habilitar envío de cookies/credentials para CORS
})

// Interceptor para agregar token a las requests
apiClient.interceptors.request.use(
  config => {
    const token = localStorage.getItem('auth_token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// Interceptor para manejar respuestas y errores
apiClient.interceptors.response.use(
  response => {
    return response
  },
  error => {
    // Manejar errores de autenticación
    if (error.response?.status === 401) {
      // Token expirado o inválido
      localStorage.removeItem('auth_token')
      localStorage.removeItem('user_data')

      // Solo redirigir si NO estamos ya en la página de login
      const currentPath = window.location.pathname
      if (currentPath !== '/login') {
        window.location.href = '/login'
      }
      toast.error(
        error.response?.data?.error?.message ||
          'Sesión expirada. Por favor, inicia sesión nuevamente.'
      )
    } else if (error.response?.status === 403) {
      toast.error('No tienes permisos para realizar esta acción.')
    } else if (error.response?.status >= 500) {
      toast.error('Error del servidor. Intenta nuevamente más tarde.')
    } else if (error.code === 'ECONNABORTED') {
      toast.error('La solicitud tardó demasiado tiempo. Intenta nuevamente.')
    } else {
      // Otros errores
      const message = error.response?.data?.message || 'Error en la solicitud'
      toast.error(message)
    }

    return Promise.reject(error)
  }
)

export default apiClient
